<template>
    <div class="field">
        <transition name="fade">
            <label v-if="title" class="field-label" :title="description || title">
                {{ title }}
                <span class="required">{{ required ? '*' : '' }}</span>
            </label>
        </transition>
        <input
            ref="widget"
            class="field-input"
            style="width: 100%;"
            type="text"
            :name="name"/>
    </div>
</template>

<script type="text/babel">
import _ from 'lodash';
import Vue from 'vue';

export default {
    name: 'kendo-multiselect',

    props: {
        dataSource: Array,
        label: String,
        name: String,
        description: String,
        placeholder: String,
        required: Boolean,
        listWidth: {
            type: Number
        },
        dataTextField: {
            type: String,
            default: 'text'
        },
        dataValueField: {
            type: String,
            default: 'value'
        },
        template: {
            type: String,
            default: ''
        },
        groupField: {
            type: String,
            default: ''
        },
        value: {
            type: [Object, Array, String, Number]
        },
        index: {
            type: Number
        }
    },

    data () {
        const value = _.isObject(this.value) && this.value.value ? _.isArray(this.value.value) ? this.value.value : [this.value.value] : _.isString(this.value) || _.isNumber(this.value) ? [this.value] : _.isArray(this.value) ? this.value : this.getValueIndex();

        const config = {
            dataTextField: this.dataTextField,
            dataValueField: this.dataValueField,
            dataSource: this.createDataSource(this.dataSource),
            template: this.template,
            value,
            change: this.onChange,
            filter: 'contains'
        };

        if (this.placeholder) {
            config.placeholder = this.placeholder;
        }
        return {
            title: this.label,
            config,
            widget: undefined
        };
    },

    mounted () {
        this.widget = new kendo.ui.MultiSelect(this.$refs.widget, this.config);

        if (this.listWidth) {
            this.widget.list.width(this.listWidth);
        }

        this.onChange({ value: this.widget.value() });
    },

    destroyed () {
        this.widget.destroy();
    },

    methods: {
        createDataSource (data) {
            const config = { data };

            if (this.groupField) {
                config.group = { field: this.groupField };
            }

            return config;
        },

        getValueIndex () {
            if (String(this.index)) {
                const dataItems = this.widget ? this.widget.dataItems() : this.dataSource;
                const data = dataItems[this.index];
                return data && data[this.dataValueField] ? [data[this.dataValueField]] : [];
            }
            return [];
        },

        formatData () {
            return {
                metadata: {
                    name: this.name,
                    text: this.dataTextField,
                    value: this.dataValueField,
                    properties: Object.keys(this.dataSource[0] || {})
                },
                value: this.widget.value(),
                text: _(_.cloneDeep(this.dataSource))
                    .filter(d => _.some(this.widget.value(), v => String(v) === String(d[this.dataValueField])))
                    .map(d => d[this.dataTextField])
                    .value()
            };
        },

        onChange () {
            const data = this.formatData();
            this.$emit('input', data);
            this.$emit('change', data);
        }
    },

    watch: {
        value (newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                Vue.nextTick(() => {
                    this.widget.value(_.isObject(newVal) ? _.isArray(newVal.value) ? newVal.value : _.isArray(newVal) ? newVal : [newVal] : []);
                });
            }
        },

        dataSource (val) {
            this.widget.setDataSource(new kendo.data.DataSource(this.createDataSource(val)));
        },

        label (val) {
            this.title = val;
        },

        dataTextField (val) {
            this.widget.setOptions({ dataTextField: val });
        },

        dataValueField (val) {
            this.widget.setOptions({ dataValueField: val });
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    $helpColor: #ff3860;
    $labelColor: #888;

    .required {
        color: $helpColor;
    }

    // Animations
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/kendo-multiselect/kendo-multiselect.component.vue